module.exports = __webpack_public_path__ + "img/0_GCE icone.8494c7f9.png";